import { useState } from "react";

import Input from "../../ui/input/Input";
import Button from "../../ui/button/Button";
import Alert from "../../ui/alert/Alert";

import "./MfaVerifyForm.css";

export default function MfaVerifyForm({
  qrCode,
  onSubmit,
  isLoading,
  serverError,
}) {
  const [code, setCode] = useState("");

  const cleanCode = code.replace(/\D/g, "");
  const canSubmit = cleanCode.length === 6 && !isLoading;

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canSubmit) return;

    onSubmit(cleanCode);
  };

  return (
    <form className="mfa-form" onSubmit={handleSubmit}>
      {serverError && <Alert type="error">{serverError}</Alert>}

      <Alert type="info">
        Scan de QR-code met Microsoft Authenticator, Google Authenticator of een
        andere MFA-app. Vul daarna de 6-cijferige code in.
      </Alert>

      {qrCode ? (
        <div className="mfa-form__qr-wrap">
          <img className="mfa-form__qr" src={qrCode} alt="MFA QR-code" />
        </div>
      ) : (
        <Alert type="error">
          Geen QR-code ontvangen van de server. Controleer de backend response.
        </Alert>
      )}

      <Input
        id="mfaCode"
        label="MFA-code"
        value={code}
        onChange={handleCodeChange}
        placeholder="123456"
        inputMode="numeric"
        maxLength={6}
        autoComplete="one-time-code"
        disabled={isLoading}
      />

      <Button type="submit" disabled={!canSubmit}>
        {isLoading ? "Code controleren..." : "Account activeren"}
      </Button>
    </form>
  );
}
